import React from "react";

const Numeric_Data_Types = () => {
  return (
    <div>
      <h1>Numeric_Data_Types Component</h1>
      <p>Content for Numeric_Data_Types goes here...</p>
    </div>
  );
};

export default Numeric_Data_Types;
